<div class="login-page">
  <div class="login-wrapper">
    <app-login-card (logedIn)="login($event)"></app-login-card>
  </div>
</div>
